import React from 'react';

const PageSpinner = () => {
    return (
        <svg width={38} height={38} viewBox="0 0 38 38" stroke="#8f99dc">
            <g
                transform="translate(1 1)"
                strokeWidth={2}
                fill="none"
                fillRule="evenodd"
            >
                <circle strokeOpacity={0.5} cx={18} cy={18} r={18} />
                <path d="M.434 14.072c-2.17 9.7 3.938 19.325 13.638 21.494">
                    <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from="0 18 18"
                        to="360 18 18"
                        dur="1s"
                        repeatCount="indefinite"
                    />
                </path>
            </g>
        </svg>
    );
};

export default PageSpinner;
